(function(exports) {
	function escapeHtml(str) {
		return new Option(str).innerHTML;
	}

	const DEBUG = false;

	class BindingAssists {
		static isNonTextInputKey(jqEvt) {
			// prevent accidentially submitting the form
			if (jqEvt.which === 13) {
				jqEvt.preventDefault();
				return true;
			}

			// ignore control characters (but allow backspace)
			if (jqEvt.which < 20 && jqEvt.which !== 8) {
				return true;
			}
			// ignore arrow keys
			if ([37, 38, 39, 40].some(k => k === jqEvt.which)) {
				return true;
			}
			// ignore control keys (if jquery sends them)
			if (jqEvt.ctrlKey || jqEvt.metaKey || jqEvt.altKey) {
				return true;
			}

			return false;
		}
	}

	class ProviderSuggestionTemplates {

		static tradingName(provider) {
			const providerNameObj = provider.name;
			const city = escapeHtml(provider.city || "");
			const country = escapeHtml(provider.countryDisplay || "");

			const cityCountryDisplay = country && city
				? `${city}, ${country}`
				: city
				? city
				: country;
			let providerNameDisplay = escapeHtml(providerNameObj.display);
			let abbreviation = escapeHtml(provider.abbreviation);

			if (provider.institutionTradingNameId) {
				providerNameDisplay = providerNameObj.tradingName;
			} else if (provider.isAbbreviationMatch) {
				providerNameDisplay = `${providerNameDisplay} (${abbreviation})`;
			}

			const line1 = `<strong class='tt-suggestion-provider-displayname'${DEBUG ? " style='color: #00FFFF'" : ""}>${providerNameDisplay}</strong>`;
			const line2 = provider.institutionTradingNameId ? `<div class='tt-suggestion-provider-actual'>${providerNameObj.name}</div>` : "";
			const line3 = cityCountryDisplay ? `<div class='tt-suggestion-provider-location'>${cityCountryDisplay}</div>` : "";

			return `<div>${line1}${line2}${line3}</div>`;
		}

		static groupName(provider) {
			let element = `<strong${DEBUG ? " style='color: #FF00FF'" : ""}><span class='group-display-icon'></span> ${escapeHtml(provider.name.display)} (group)</strong>`;
			let memberNames = provider.members.reduce((o, m) => `${o}, ${escapeHtml(m.name)}`, "");
			let remainingMemberCount = provider.memberCount - provider.members.length;

			element += `<br /><small><em>incl:${memberNames.substring(1)}`;

			if (provider.memberCount > provider.members.length) {
				element += `, ${remainingMemberCount} others.`;
			}
			element += "</em></small>";

			return element;
		}

		groupOrTradingName (provider) {
			return provider.type === "group" ? ProviderSuggestionTemplates.groupName(provider)
				: ProviderSuggestionTemplates.tradingName(provider);
		}
	}

	exports.Selectors = exports.Selectors || {};
	exports.Selectors.SuggestionTemplates = {
		Provider: new ProviderSuggestionTemplates()
	};
	exports.Selectors.BindingAssists = BindingAssists;
})(window.App = window.App || {});
